export default __webpack_public_path__ + "static/media/logo_main.6fb5b369.png";